import { SVGInterface } from "../../interface";

const FileAdd = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_2_49639)">
      <path
        d="M18 22H6C4.89543 22 4 21.1046 4 20V4.00002C4 2.89545 4.89543 2.00002 6 2.00002H13C13.009 1.99886 13.018 1.99886 13.027 2.00002H13.033C13.0424 2.00298 13.0522 2.00498 13.062 2.00602C13.1502 2.01167 13.2373 2.02882 13.321 2.05702H13.336H13.351H13.363C13.3815 2.06994 13.3988 2.08432 13.415 2.10002C13.5239 2.14844 13.6232 2.2162 13.708 2.30002L19.708 8.30002C19.7918 8.3848 19.8596 8.48407 19.908 8.59302C19.917 8.61502 19.924 8.63602 19.931 8.65902V8.67302V8.68702C19.9589 8.77041 19.9754 8.8572 19.98 8.94502C19.9809 8.95498 19.9832 8.96475 19.987 8.97402V8.98002C19.9921 8.98617 19.9964 8.99288 20 9.00002V20C20 21.1046 19.1046 22 18 22ZM6 4.00002V20H18V10H13C12.4477 10 12 9.5523 12 9.00002V4.00002H6ZM14 5.41402V8.00002H16.586L14 5.41402ZM13 18H11V16H9V14H11V12H13V14H15V16H13V18Z"
        fill={color || "#0E171F"}
      />
    </g>
    <defs>
      <clipPath id="clip0_2_49639">
        <rect {...rest} width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FileAdd;
